import script from "./SupervisorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SupervisorPage.vue?vue&type=script&setup=true&lang=js"

import "./SupervisorPage.vue?vue&type=style&index=0&id=45db9d1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45db9d1c"]])

export default __exports__